import React from 'react';

import FeaturesList from '../FeaturesList';

export const EnterpriseFeaturesList = () => (
  <FeaturesList
    features={['Up to 100 properties']}
  />
);
